<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <vs-row>
                    <vs-col sm="12" lg="7">
                        <h4 class="p-2">Docentes</h4>
                    </vs-col>
                    <vs-col sm="12" lg="5" class="d-flex justify-content-end">
                        <vs-button
                            color="#7d33ff"
                            flat
                            @click="activeVincular =! activeVincular, boton = 'nuevo'"
                        >
                            <i class="fas fa-people-arrows mr-1"></i> Vincular docente
                        </vs-button>
                        <vs-button
                            success
                            flat
                            @click="activeRegistro =! activeRegistro"
                        >
                            <i class="fas fa-plus mr-1"></i> Crear registro / Carga masiva
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <vs-select filter label="Institución" placeholder="Seleccionar institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="instituciones.length" autocomplete="off">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <vs-select filter :loading="loadingPrograma" label="Programa" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" autocomplete="off">
                                <template v-if="programas.length" autocomplete="off">
                                    <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                            <div v-if="programa !== ''" @click="programa = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <vs-input
                            label="Nombre de docente"
                            v-model="nombre"
                            placeholder="Nombre de docente"
                        />
                    </vs-col>
                    <vs-col w="12">
                        <vs-button
                            class="ml-auto"
                            @click="getDocentes()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                    <vs-col w="12">
                        <vs-button
                            class="ml-auto"
                            flat
                            @click="getPlantilla()"
                        >
                            <i class="fas fa-download mr-2"></i> Descargar plantilla para vincular docentes
                        </vs-button>
                    </vs-col>
                    <vs-col w="12" v-if="users[0]">
                        <vs-button
                            :loading="loadingExcel"
                            class="ml-auto"
                            flat
                            success
                            @click="getExcel()"
                        >
                            <i class="fas fa-file-csv mr-2"></i> Descargar archivo de excel
                        </vs-button>
                    </vs-col>
                </vs-row>
                <docentes :users="users" :pages="pages" :instituciones="instituciones" :institucion="institucion" @refreshTable="getDocentes"></docentes>
                <vincular v-model="activeVincular" :instituciones="instituciones" :boton="boton"></vincular>
                <registro v-model="activeRegistro" :instituciones="instituciones" :institucion="institucion" :csrf_token="csrf_token" @refreshTable="getDocentes"></registro>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import academico from '../../../../api/requests/academico.js'
import docentes from './tabla-docentes.vue'
import vincular from './modales/vincular.vue'
import registro from './modales/registro.vue'
import masiva from './modales/carga-masiva.vue'
export default {
    props:[
        'csrf_token'
    ],
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            nombre: '',
            errorFields: [],
            pages: 0,
            page: 1,
            users: [],
            activeVincular: false,
            activeRegistro: false,
            activeMasiva: false,
            boton: '',
            tache: false,
            loadingExcel: false
        }
    },
    components:{
        docentes,
        vincular,
        registro,
        masiva
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
            }
            catch{

            }
        },
        async getPrograma(){
            if (this.institucion) {
                this.programa = ''
                this.loadingPrograma = true
                try {
                    const {data: response} = await academico.getPrograma(this.institucion)
                    this.programas = response
                    this.programaId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        async getDocentes(page){
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }else{
                const loading = this.$vs.loading()
                try {
                    const params = {
                        page: page ? page : this.page,
                        institucion_id: this.institucion,
                        nombre: this.nombre,
                        type_response: "online"
                    }
                    if(programa != ''){
                        params.programa_id = this.programa
                    }
                    const {data: response} = await academico.getDocentes(params)
                    loading.close()
                    const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
                    this.pages = Math.ceil(total/per_page) || 0
                    this.users = dataTable
                }
                catch{
                    loading.close()
                }
            }
        },
        
        getExcel () {
            this.loadingExcel = true
            let formData = {
                institucion_id: this.institucion,
                type_response: "file"
            }
            this.loading = true
            setTimeout(() => {
                axios.get('/docentes/show', {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loading = false;
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
        async getPlantilla(){
            window.location.href = '/docentes/downloadExcel'
        }
    },
    watch:{
        institucion(){
            this.getPrograma()
        }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 20px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>